import React, { useState } from 'react';
import SmallImg from '../assets/NewHome/smallRect.png';
import VerticalCards from '../assets/NewHome/verticalCard.png';
import EarlyAccessForm from './EarlyAccessForm';

const MobileHero = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showFreeAccountForm, setShowFreeAccountForm] = useState(false);

  return (
    <div className="relative overflow-hidden" style={{
      background: 'linear-gradient(180deg, #0d0525 0%, #4A3AFF 50%, #4A3AFF 70%, #4A3AFF 100%)',
      borderRadius: '0 0 50px 50px'
    }}>
      {/* Main Content Container */}
      <div
        className="relative z-10 px-6 pb-8 flex flex-col items-center"
        style={{ paddingTop: '15vh' }}
      >
        {/* Light Purple Tab/Content Block */}
        <div className="relative bg-[#4A3AFF] p-4 w-full max-w-[560px] rounded-2xl rounded-t-none">
          <img src={SmallImg} alt="small" className="w-32 h-auto absolute -top-10 right-0" />
          {/* Headline */}
          <h1 className="text-white text-3xl sm:text-4xl font-bold mb-4 leading-tight" style={{
            fontFamily: "'Bricolage Grotesque', sans-serif",
            fontWeight: 700
          }}>
            Win more deals.<br />
            Be more billable.
          </h1>

          {/* Subheading */}
          <h2 className="text-white text-lg sm:text-xl font-semibold mb-4" style={{
            fontFamily: "'Bricolage Grotesque', sans-serif",
            fontWeight: 600
          }}>
            AI Sales Platform<br />
            for consulting firms.
          </h2>

          {/* Descriptive Paragraph */}
          <p className="text-white text-sm sm:text-base leading-relaxed mb-6" style={{
            fontFamily: "'Bricolage Grotesque', sans-serif",
            fontWeight: 300,
            opacity: 0.95
          }}>
            From discovering new leads, researching opportunities to creating proposals, our AI agents automate the sales process, while you focus on delivery.
          </p>

          {/* Stacked Documents Illustration */}
          <div className="relative mt-6 mb-2 flex justify-end items-end h-28 pr-2">
            <div className="" style={{ width: '140px', height: '90px' }}>
              
              <img src={VerticalCards} alt="medium" className="w-32 h-auto absolute top-0 left-8" />
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="flex justify-center mt-8">
          <button
            className="shimmer-button flex items-center justify-center gap-2.5 px-10 py-6 rounded-full text-sm font-normal transition-all duration-300 hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 relative z-10 touch-manipulation"
            style={{
              background: '#FFF5F1',
              fontFamily: "'Bricolage Grotesque', sans-serif",
              minWidth: '300px',
              WebkitTapHighlightColor: 'transparent'
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowFreeAccountForm(true);
            }}
            onTouchStart={(e) => {
              e.stopPropagation();
            }}
          >
            <span className="relative z-10">Get your free account</span>
            <div className="arrow-container relative z-10">
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay (optional - can be expanded) */}
      {isMenuOpen && (
        <div 
          className="fixed inset-0 z-30 bg-black bg-opacity-50"
          onClick={() => setIsMenuOpen(false)}
        >
          {/* Menu content can be added here */}
        </div>
      )}

      {/* Free account modal */}
      {showFreeAccountForm && (
        <div
          className="fixed inset-0 z-[9999] bg-black bg-opacity-50 flex items-center justify-center p-3 sm:p-4 overflow-y-auto"
          onClick={() => setShowFreeAccountForm(false)}
          style={{ 
            WebkitOverflowScrolling: 'touch',
            overscrollBehavior: 'contain'
          }}
        >
          <div 
            onClick={(e) => e.stopPropagation()}
            className="w-full max-w-full my-auto"
          >
            <EarlyAccessForm />
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileHero;
